import PropTypes from 'prop-types';

export const supplementalTitleShape = PropTypes.arrayOf(
	PropTypes.shape({
		name: PropTypes.string,
		label: PropTypes.string,
		value: PropTypes.string,
		labeledValue: PropTypes.string
	})
);

const vehiclePropType = PropTypes.shape({
	accountId: PropTypes.string,
	attributes: PropTypes.arrayOf(PropTypes.shape({})),
	bestIncentiveIds: PropTypes.arrayOf(PropTypes.string),
	bodyStyle: PropTypes.string,
	callout: PropTypes.arrayOf(PropTypes.shape({})),
	certified: PropTypes.bool,
	classification: PropTypes.string,
	condition: PropTypes.string,
	featuredPromotion: PropTypes.bool,
	fuelType: PropTypes.string,
	highlightedAttributes: PropTypes.arrayOf(PropTypes.shape({})),
	images: PropTypes.arrayOf(PropTypes.shape({})),
	incentiveIds: PropTypes.arrayOf(PropTypes.string),
	inventoryButtons: PropTypes.arrayOf(PropTypes.shape({})),
	isNewCarBoost: PropTypes.bool,
	isPlaceholder: PropTypes.bool,
	link: PropTypes.string,
	make: PropTypes.string,
	model: PropTypes.string,
	offSite: PropTypes.bool,
	packages: PropTypes.arrayOf(PropTypes.string),
	pricing: PropTypes.shape({
		dprice: PropTypes.arrayOf(PropTypes.shape({})),
		dPrice: PropTypes.arrayOf(PropTypes.shape({})),
		eprice: PropTypes.arrayOf(PropTypes.shape({})),
		ePrice: PropTypes.arrayOf(PropTypes.shape({}))
	}),
	priorityType: PropTypes.string,
	spotlightedVehicle: PropTypes.bool,
	status: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	stockNumber: PropTypes.string,
	supplementalTitle: supplementalTitleShape,
	title: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.arrayOf(PropTypes.string)
	]),
	trackingAttributes: PropTypes.arrayOf(
		PropTypes.shape({
			name: PropTypes.string,
			value: PropTypes.string
		})
	),
	trim: PropTypes.string,
	// TODO: `vehicle.type` will always be a string once all sites are on WIS
	type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	uuid: PropTypes.string,
	videos: PropTypes.arrayOf(PropTypes.shape({})),
	vin: PropTypes.string,
	year: PropTypes.number
});

export default vehiclePropType;
